import axios from "axios";
import settings from "utils/settings";
import filterTypes from "data/filter-types";

const apiUrl = `${settings.apiUrl}api/phone-codes`;

export const requestSingle = (id) =>
  axios.post(`${apiUrl}/search?page=0&size=1`, {
    criteria: [{
      fieldName: "id",
      fieldValue: id,
      searchOperation: filterTypes.EQUALS.value
    }]
  });

export const requestAdd = (data) =>
  axios.post(`${apiUrl}`, data);



// WEBPACK FOOTER //
// ./src/actions/phone-codes/requests.js